export const classificacaoStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600&display=swap');

  .fs-root {
    --c-bg: transparent;
    --c-surface: #ffffff;
    --c-card: #ffffff;
    --c-border: rgba(15,23,42,0.08);
    --c-text: #0f172a;
    --c-muted: rgba(100,116,139,0.9);
    --c-yes: #22c55e;
    --c-no: #ef4444;
    --c-yes-bg: rgba(34,197,94,0.08);
    --c-no-bg: rgba(239,68,68,0.08);
    background: var(--c-bg);
    font-family: 'DM Sans', system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif;
    color: var(--c-text);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    width: 100%;
    margin: 0 auto;
    padding: 8px 0 16px;
    box-sizing: border-box;
    gap: 16px;
  }

  .fs-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 20px;
    margin-bottom: 16px;
  }

  .fs-logo {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 22px;
    letter-spacing: 2px;
    color: var(--c-text);
  }

  .fs-dots {
    display: flex;
    gap: 4px;
  }

  .fs-dot {
    width: 6px; height: 6px;
    border-radius: 50%;
    background: var(--c-border);
    transition: background 0.3s;
  }
  .fs-dot.done { background: var(--c-yes); }
  .fs-dot.current { background: var(--c-text); }

  .fs-stack {
    position: relative;
    width: 100%;
    max-width: 420px;
    height: min(60vh, 420px);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }

  .fs-card {
    position: absolute;
    width: 100%;
    max-width: 360px;
    height: 100%;
    max-height: 400px;
    border-radius: 20px;
    overflow: hidden;
    border: 1px solid var(--c-border);
    background: var(--c-card);
    transform-origin: center bottom;
    will-change: transform;
    touch-action: none;
    user-select: none;
    -webkit-user-select: none;
    display: flex;
    flex-direction: column;
  }

  .fs-card.is-top {
    cursor: grab;
    z-index: 10;
  }
  .fs-card.is-top:active { cursor: grabbing; }

  .fs-card.behind-1 {
    transform: scale(0.95) translateY(12px);
    filter: brightness(0.6);
    pointer-events: none;
    z-index: 1;
  }

  .fs-card.behind-2 {
    transform: scale(0.90) translateY(24px);
    filter: brightness(0.4);
    pointer-events: none;
    z-index: 0;
  }

  .fs-card-img {
    width: 100%;
    height: 100%;
    max-height: none;
    object-fit: cover;
    display: block;
    background: #1a1a28;
    pointer-events: none;
  }

  .fs-card-image-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    max-height: none;
    flex: 1 1 auto;
  }

  .fs-card-image-wrapper-clickable {
    cursor: zoom-in;
  }

  .fs-img-placeholder {
    width: 100%;
    height: 100%;
    max-height: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #1a1a28;
    gap: 12px;
    color: rgba(255,255,255,0.2);
    font-size: 13px;
  }

  .fs-gif-badge {
    position: absolute;
    top: 14px; right: 14px;
    background: rgba(0,0,0,0.65);
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 1px;
    padding: 4px 8px;
    color: rgba(255,255,255,0.7);
    border: 1px solid rgba(255,255,255,0.1);
    z-index: 5;
    pointer-events: none;
  }

  .fs-hint {
    position: absolute;
    top: 28px;
    padding: 8px 18px;
    border-radius: 10px;
    font-family: 'Bebas Neue', sans-serif;
    font-size: 28px;
    letter-spacing: 2px;
    pointer-events: none;
    border: 3px solid;
    z-index: 20;
    transition: opacity 0.08s;
  }

  .fs-hint-yes {
    left: 18px;
    color: var(--c-yes);
    border-color: var(--c-yes);
    transform: rotate(-15deg);
  }

  .fs-hint-no {
    right: 18px;
    color: var(--c-no);
    border-color: var(--c-no);
    transform: rotate(15deg);
  }

  .fs-overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 8;
    border-radius: 24px;
    transition: opacity 0.08s;
  }

  .fs-overlay-yes { background: var(--c-yes-bg); }
  .fs-overlay-no { background: var(--c-no-bg); }

  .fs-info {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 12px 16px 14px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    background: linear-gradient(
      0deg,
      rgba(15,23,42,0.98) 0%,
      rgba(15,23,42,0.94) 35%,
      rgba(15,23,42,0.88) 65%,
      transparent 100%
    );
    box-sizing: border-box;
  }

  .fs-name {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 26px;
    letter-spacing: 1.5px;
    line-height: 1.1;
    color: #f9fafb;
    text-shadow: 0 1px 2px rgba(15,23,42,0.8);
  }

  .fs-tags {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }

  .fs-tag {
    font-size: 11px;
    font-weight: 500;
    padding: 3px 10px;
    border-radius: 20px;
    background: rgba(15,23,42,0.75);
    color: #e5e7eb;
    border: 1px solid rgba(148,163,184,0.7);
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  .fs-actions {
    display: flex;
    gap: 28px;
    align-items: center;
    margin-top: 28px;
    z-index: 20;
  }

  .fs-btn {
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.15s, box-shadow 0.15s;
    outline: none;
    background: none;
    padding: 0;
  }
  .fs-btn:active { transform: scale(0.88); }

  .fs-btn-no {
    width: 64px; height: 64px;
    background: rgba(255,69,96,0.12);
    border: 2px solid rgba(255,69,96,0.3);
    color: var(--c-no);
  }
  .fs-btn-no:hover { box-shadow: 0 0 20px rgba(255,69,96,0.25); }

  .fs-btn-yes {
    width: 64px; height: 64px;
    background: rgba(34,216,122,0.12);
    border: 2px solid rgba(34,216,122,0.3);
    color: var(--c-yes);
  }
  .fs-btn-yes:hover { box-shadow: 0 0 20px rgba(34,216,122,0.25); }

  .fs-btn-undo {
    width: 44px; height: 44px;
    background: rgba(255,255,255,0.05);
    border: 1px solid var(--c-border);
    color: var(--c-muted);
  }

  .fs-score-row {
    display: flex;
    gap: 28px;
    margin-top: 18px;
    z-index: 20;
  }

  .fs-score-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
    color: var(--c-muted);
  }

  .fs-score-num {
    font-weight: 600;
    font-size: 15px;
  }

  .fs-done {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
    padding: 32px 20px;
    z-index: 20;
  }

  .fs-done-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 48px;
    letter-spacing: 3px;
    line-height: 1;
  }

  .fs-done-sub {
    font-size: 15px;
    color: var(--c-muted);
    max-width: 280px;
    line-height: 1.6;
  }

  .fs-done-stats {
    display: flex;
    gap: 32px;
    margin-top: 12px;
  }

  .fs-done-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .fs-done-stat-num {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 42px;
    line-height: 1;
  }

  .fs-done-stat-label {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: var(--c-muted);
  }

  .fs-btn-restart {
    margin-top: 12px;
    background: rgba(255,255,255,0.07);
    border: 1px solid var(--c-border);
    color: var(--c-text);
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    padding: 12px 28px;
    border-radius: 50px;
    cursor: pointer;
    letter-spacing: 0.5px;
    transition: background 0.2s;
  }
  .fs-btn-restart:hover { background: rgba(255,255,255,0.12); }

  .fs-image-modal {
    position: fixed;
    inset: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fs-image-modal-backdrop {
    position: absolute;
    inset: 0;
    background: rgba(15,23,42,0.75);
    backdrop-filter: blur(4px);
  }

  .fs-image-modal-content {
    position: relative;
    z-index: 1;
    max-width: 90vw;
    max-height: 80vh;
    border-radius: 18px;
    overflow: hidden;
    background: #020617;
    box-shadow: 0 24px 48px rgba(15,23,42,0.6);
  }

  .fs-image-modal-img {
    display: block;
    max-width: 100%;
    max-height: 80vh;
    object-fit: contain;
    background: #020617;
  }

  .fs-image-modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: rgba(15,23,42,0.85);
    color: #e5e7eb;
    cursor: pointer;
  }

  @media (max-height: 700px) {
    .fs-stack {
      height: min(55vh, 360px);
    }

    .fs-card {
      max-height: 360px;
    }

    .fs-actions {
      margin-top: 20px;
      gap: 20px;
    }

    .fs-score-row {
      margin-top: 12px;
    }
  }

  @media (max-height: 600px) {
    .fs-stack {
      height: min(50vh, 320px);
    }

    .fs-card {
      max-height: 320px;
    }

    .fs-done {
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }
`;

